/* eslint-disable max-statements */
import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { SCREEN_NAMES } from "../pre-delivery-inspection-lead-form-parent/constant";
import styles from "./styles.css";
import CarBrands from "../car-brands";
import { NUMBER } from "../../../constants/app-constants";
import { STEP_NAMES } from "../pre-delivery-inspection-vehicle-info-screen/constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiBrandClicked, pdiRegNumberEntered, pdiViewAllBrand } from "../../../constants/tracking-constants/pre-delivery-inspection";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";
// import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import { Label } from "@cars24/turbo-web/lib/label";
import { InputForm } from "@cars24/turbo-web/lib/input-form";
import { Button } from "@cars24/turbo-web/lib/button";
import { Divider } from "@cars24/turbo-web/lib/divider";
import Prefix from "./images/prefix.svg";
import Cross from "./images/cross.svg";
import { IconButton } from "@cars24/turbo-web/lib/icon-button";
import formatInputValue from "../../../utils/helpers/format-input-value";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Modal } from "@cars24/turbo-web/lib/modal";
import { Text } from "@cars24/turbo-web/lib/text";
import pdiIneligible from "./images/pdi-ineligible.svg";

const PreDeliveryInspectionFormScreen = ({
    setFormActiveScreenConnect,
    popularBrands,
    brand,
    fetchBrandsConnect,
    getVehicleDetailConnect,
    setDetailsConnect,
    checkPdiEligibilityConnect
    // priceDetails,
    // isSsr,
    // getPreDeliveryInspectionPriceConnect
}) => {
    const { tokens } = useTokens();
    const [isLoading, setIsLoading] = useState(false);
    // const regNoRef = useRef("");
    const [isError, setIsError] = useState(false);
    const [popularBrandList, setPopularBrandList] = useState(popularBrands);
    const [regNo, setRegNo] = useState("");
    const [showModal, setShowModal] = useState(false);

    // useEffect(() => {
    //     if (!isSsr && isObjectEmpty(priceDetails)) {
    //         getPreDeliveryInspectionPriceConnect();
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isSsr]);

    const handleOnChange = useCallback((e) => {
        const { target: {value = ""} = {} } = e || {};
        const regexp = /[^a-z0-9]/gi;
        const sanitizedValue = (value || "").replace(regexp, "").toUpperCase();
        setRegNo(sanitizedValue.trim());
        setIsError(false);
    }, []);

    const registrationNumberValidator = useCallback((v) => {
        return isValidRegistrationNo(v.replace(/\s/g, ""));
    }, []);

    const updateStateForInvalidRegistration = useCallback(() => {
        setIsLoading(false);
        setIsError(true);
    }, []);

    const handleBookInspection = async () => {
        setIsLoading(true);
        if (!registrationNumberValidator(regNo)) {
            updateStateForInvalidRegistration();
            return;
        }

        checkPdiEligibilityConnect({ regNumber: regNo })
            .then(async (res) => {
                const { isEligible = true } = res || {};
                if (isEligible) {
                    getVehicleDetailConnect(regNo).then(async (response) => {
                        await yieldToMain();
                        if (response.redirectToDetails) {
                            setFormActiveScreenConnect(SCREEN_NAMES.confirmCarDetailsScreen);
                        } else {
                            setFormActiveScreenConnect(SCREEN_NAMES.vehicleInfoScreen);
                        }
                    }).catch(() => { });
                } else {
                    setShowModal(true);
                }
            })
            .catch(() => { })
            .finally(() => setIsLoading(false));

        await yieldToMain();
        sendCustomGaEvents(pdiRegNumberEntered);
    };

    const handleBrandClick = async (selectedBrand) => {
        setFormActiveScreenConnect(SCREEN_NAMES.vehicleInfoScreen);
        setDetailsConnect({
            [STEP_NAMES.Brand]: { name: selectedBrand.displayText, id: selectedBrand.id },
            ...(brand.id !== selectedBrand.id && {[STEP_NAMES.Model]: {}}),
            activeAccordionStepIndex: NUMBER.ONE
        });
        await yieldToMain();
        sendCustomGaEvents({
            ...pdiBrandClicked,
            eventLabel: selectedBrand.displayText
        });
    };

    const handleViewAllBrands = async () => {
        setFormActiveScreenConnect(SCREEN_NAMES.vehicleInfoScreen);
        await yieldToMain();
        sendCustomGaEvents(pdiViewAllBrand);
    };

    const handleBack = () => {
        setFormActiveScreenConnect(SCREEN_NAMES.intentScreen);
    };

    const handleReset = () => {
        setShowModal(false);
        setRegNo("");
    };

    useEffect(() => {
        if ((popularBrands || []).length > NUMBER.ZERO) {
            setIsLoading(false);
        } else {
            setIsLoading(true);
            fetchBrandsConnect()
                .then(() => {
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        }
        setPopularBrandList(popularBrands);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [popularBrands]);

    return (
        <div styleName={"styles.leadForm"}>
            <div styleName={"styles.leadformTitle"}>
                <IconButton onClick={handleBack} size="small" rounded={true}>
                    <img src={Cross} alt="cross" />
                </IconButton>
                <Label level={NUMBER.THREE} fontWeight="semibold" color={tokens.text_default_text_primary}>Enter car details</Label>
            </div>
            <div styleName={"styles.inputContainer"}>
                <InputForm
                    onChange={handleOnChange}
                    type="text"
                    isError={isError}
                    customErrorMessage="Please enter a valid car number"
                    label="Enter your vehicle number"
                    prefix={<img styleName={"styles.inputImage"} src={Prefix} alt="prefix"/>}
                    validator={(e) => registrationNumberValidator(e)}
                    allowClear={false}
                    placeholder="DL 12 AA 12XX"
                    value={formatInputValue(regNo)}
                />
            </div>
            <div styleName={"styles.bookInspection"}>
                <Button
                    label={`Book Inspection`}
                    loading={isLoading}
                    onClick={handleBookInspection}
                    size="large"
                />
            </div>

            <div styleName={"styles.divider"}>
                <Divider variant="tertiary" />
            </div>
            <div styleName={"styles.brandsTitle"}>
                <Label level={NUMBER.TWO} fontWeight="medium" color={tokens.text_default_text_secondary}>Start with your car brand</Label>
            </div>
            <div styleName={"styles.carBrand"}>
                <CarBrands
                    popularItems={popularBrandList}
                    size={NUMBER.SEVEN}
                    stepName={STEP_NAMES.Brand}
                    expandable={true}
                    selected={brand?.id || 0}
                    isRevamped={true}
                    onMoreClickCallback={handleViewAllBrands}
                    isLazyLoad={false}
                    onBrandClick={handleBrandClick}
                    ctaText={"View all"}
                />
            </div>
            <Modal
                isOpen={showModal}
                overlayColor={tokens.background_surface_overlay_primary}
                width="846px"
                height="fit-content"
                onClose={handleReset}
            >
                <div styleName={"styles.modalContainer"}>
                    <div styleName={"styles.modalText"}>
                        <Text as="p" size="450" fontWeight="semibold" align="center">This car is not available for inspection</Text>
                        <Text as="p" size="300" align="center">We cannot provide a pre-delivery check for this car</Text>
                    </div>
                    <img src={pdiIneligible} alt="pdi ineligible" styleName={"styles.modalImg"} />
                    <Button
                        label="Try with another car"
                        size="large"
                        onClick={handleReset}
                    />
                </div>
            </Modal>

        </div>
    );
};

export default PreDeliveryInspectionFormScreen;

PreDeliveryInspectionFormScreen.propTypes = {
    setFormActiveScreenConnect: PropTypes.func,
    fetchBrandsConnect: PropTypes.func,
    popularBrands: PropTypes.array,
    setDetailsConnect: PropTypes.func,
    brand: PropTypes.object,
    getVehicleDetailConnect: PropTypes.func,
    history: PropTypes.object,
    priceDetails: PropTypes.object,
    isSsr: PropTypes.bool,
    getPreDeliveryInspectionPriceConnect: PropTypes.func,
    newCarPdiLead: PropTypes.bool,
    checkPdiEligibilityConnect: PropTypes.func
};
